import { Link } from "react-router-dom"
import classNames from "classnames"
import { v4 as uuidv4 } from "uuid"

import { UITypes } from "types"
import { ReactComponent as IconArrow } from "assets/svg/icon-breadcrumb-arrow.svg"

import styles from "./index.module.scss"

interface Props {
  list?: UITypes.Breadcrumb[]
}

export const Breadcrumbs = ({ list }: Props) => {
  if (!list?.length) return null

  return (
    <div className={styles.breadcrumbsWrapper}>
      {list.map((item, index) => {
        const isLast = index === list.length - 1
        return item.link ? (
          <Link key={uuidv4()} to={item.link} className={styles.breadcrumb}>
            <span className={classNames({ [styles.lastBreadcrumb]: isLast })}>{item.label}</span>
            {!isLast && <IconArrow className={styles.breadcrumbIcon} />}
          </Link>
        ) : (
          <span key={uuidv4()} className={styles.breadcrumb}>
            <span className={classNames({ [styles.lastBreadcrumb]: isLast })}>{item.label}</span>
            {!isLast && <IconArrow className={styles.breadcrumbIcon} />}
          </span>
        )
      })}
    </div>
  )
}
